exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hollow-dots-spinner[data-v-6a541738],.hollow-dots-spinner [data-v-6a541738]{box-sizing:border-box}.hollow-dots-spinner[data-v-6a541738]{height:15px;width:90px}.hollow-dots-spinner .dot[data-v-6a541738]{width:15px;height:15px;margin:0 7.5px;border:3px solid #ff1d5e;border-radius:50%;float:left;transform:scale(0);animation:hollow-dots-spinner-animation-data-v-6a541738 1s ease infinite 0ms}.hollow-dots-spinner .dot[data-v-6a541738]:first-child{animation-delay:0.3s}.hollow-dots-spinner .dot[data-v-6a541738]:nth-child(2){animation-delay:0.6s}.hollow-dots-spinner .dot[data-v-6a541738]:nth-child(3){animation-delay:0.9s}@keyframes hollow-dots-spinner-animation-data-v-6a541738{50%{transform:scale(1);opacity:1}to{opacity:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a541738","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/epic-spinners/src/components/lib/HollowDotsSpinner.vue
// module id = 419
// module chunks = 0